import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useQuotePackagesPreviewModeStyles = createStyles(({ token }) => ({
  newQuotePackageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
    borderBottom: `1px solid ${token.colorWhite}`,
    color: ThemeColors.COLOR_GREY3,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: 17,
    fontWeight: 700,
    height: 30,
    marginBottom: ThemeSpaces.SPACE_NORM0_5,
    paddingLeft: ThemeSpaces.SPACE_NORM,
    paddingRight: ThemeSpaces.SPACE_NORM_20,
  },
  newQuotePackageControlButtons: {
    display: 'flex',
    alignItems: 'center',

    '.IconButton-Icon': {
      color: token.colorPrimary,
      paddingLeft: ThemeSpaces.SPACE_NORM,
    },
  },
}));
